import styled from "@emotion/styled";

function Home() {
  return <Container>Home</Container>;
}

const Container = styled.div``;

export default Home;
